<template>
  <v-container>
    <v-layout row>
      <v-flex class="py-3">
        <v-btn flat class="primary" router @click="back()">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex class="mb-3">
        <h1>{{courseName}}</h1>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="!loaded">
      <v-flex offset-xs5 offset-sm6 pt-5>
        <v-progress-circular :size="70" :width="7" color="light-blue darken-4" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-card v-if="loaded">
      <v-card-title class="headline">
        Utenti Registrati
        <v-spacer></v-spacer>
      </v-card-title>
      <v-layout row wrap mb-3>
        <v-spacer></v-spacer>
        <v-flex xs12 md8 lg5 mx-3>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Cerca"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="users"
        :search="search"
        :loading="loading"
        :rows-per-page-items="[10,25,40]"
        rows-per-page-text="Righe per pagina"
      >
        <template v-slot:items="props">
          <td>{{ props.item.cognome }}</td>
          <td>{{ props.item.nome }}</td>
          <td>{{ props.item.email }}</td>
        </template>
        <template v-slot:no-results>
          <v-alert
            :value="true"
            color="error"
            icon="warning"
          >La tua ricerca per "{{ search }}" non ha dato risultati.</v-alert>
        </template>
        <template v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">Nessun valore da visualizzare</v-alert>
        </template>
        <template
          v-slot:pageText="props"
        >{{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { bus } from "../main";
import { db } from "../main";
export default {
  data: () => ({
    courseID: "",
    courseName: "",
    search: "",
    signedUsers: [],
    users: [],
    headers: [
      {
        text: "Cognome",
        value: "cognome"
      },
      {
        text: "Nome",
        value: "nome"
      },
      {
        text: "Email",
        align: "left",
        value: "email"
      }
    ],
    loaded: false,
    loading: false
  }),
  methods: {
    //metodo per far tornare l'utente alla pagina precedente a quella attuale
    back() {
      window.history.back();
    }
  },
  computed: {
    //controlla se l'utente è admin
    isUserAdmin() {
      return this.$store.getters.getRole === "Admin";
    }
  },

  //crea l'elenco degli utenti iscritti al corso selezionato
  created() {
    const course = this.$store.getters.getCourse;
    this.courseID = course.id;
    this.courseName = course.courseName;
    db.collection("iscritti")
      .where("id_corso", "==", this.courseID)
      .get()
      .then(list => {
        list.forEach(element => {
          if (element.data().id_corso === this.courseID) {
            this.signedUsers.push(element.data().id_utente);
          }
        });
        db.collection("utenti")
          .get()
          .then(list => {
            list.forEach(user => {
              if (this.signedUsers.includes(user.id)) {
                const usr = {
                  email: user.data().email,
                  nome: user.data().nome,
                  cognome: user.data().cognome
                };
                this.users.push(usr);
              }
            });
            this.loaded = true;
          })
          .catch(error => {
            bus.$emit(
              "errorOperation",
              "Errore: problema nel caricamento dell'elenco dei partecipanti al corso(" +
                error +
                ")"
            );
          });
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore: problema nel caricamento dell'elenco dei partecipanti al corso(" +
            error +
            ")"
        );
      });
  }
};
</script>
